import { useTextes } from '@common/config';
import { z } from 'zod';
import { Z_TEXT } from '../primitives';

const t = useTextes('Commun', 'Formulaire');

export const Z_EMAIL =
  Z_TEXT(t['ADM_MES7'])
    .pipe(
      z.email({ error: t['ADM_MES2'] }),
    );

export const EMAIL_PLACEHOLDER = 'd.thomas@gmail.com';